module.exports = {
    new:'最新发布',
    time:'发布时间：',
    watch: '阅读全文',
    hotlook: '最热点击',
    looknum: '阅读数量：',
    detail: '查看详情',
    diary: '个人随笔',
    lookall: '阅读全文',
    live: '生下来，活下去',
    friendlink:'友情链接',
    shouce:'在线手册',
    grassortree:'小草or大树',
    test:'php考核',
    search:'搜索',
    input:'请输入内容',
    select:'请选择',
    articletitle:'文章标题',
    articlecon:'文章内容',
    know:'考试须知',
    begintest:'开始考试',
    giveanswer:'提交答案',
    endtest:'考试结束',
    retest:'重新考试',
    noanswer:'答案选项不能为空',
    selecttype:'请先选择选项类型',
    oneright:'只能有一个正确答案',
    noright:'不能没有正确答案',
    noquestion:'问题不能为空',
    questiontype:'请先选择问题类型',
    lookanswer:'是否提交问题以查看所有正确答案?',
    givequestion:'提交问题',
    lookgrade:'只看分数',
    istest:'是否开始检测自己的水平?',
    conformtest:'确定考试',
    thinkabout:'容朕想想',
    testtitle:'是否开始考试',
    cancletest:'千里之行,始于足下',
    giveanswers:'是否提交答案?',
    conformgive:'确认提交',
    submitanswer:'提交答案',
    miss:'还有漏网之鱼',
    threetofive:'答案选项三到五个',
    submitok:'提交成功，感谢您的提交!',
    submitfail:'提交失败',
    leastfive:'最多五个选项',
    useemail:'用于发送正确答案到你的邮箱',
    question:'技术问题',
    questionstatus:'问题类型',
    other:'其他',
    thank:'感谢你提交问题！',
    answerlist:'答案选项',
    rightanswer:'正确答案',
    wronganswer:'错误答案',
    submitquestion:'提交',
    addquestion:'新增答案选项',
    del:'删除',


    publish: '发布时间',
    clicknum: '点击量',
    comment: '发表评论',
    comment_r1: '请输入评论内容',
    comment_r2: '评论内容在 5 到 50 个字符',
    comment_content: '评论内容',
    required:'必填',
    name:'中文名称',
    name_req:'请输入名称',
    name_r1:'请输入中文名称',
    name_r2:'中文名称在 3 到 15 个字符',
    email:'电子邮箱',
    email_r1:'请输入电子邮箱',
    email_r2:'请输入正确的邮箱地址',
    email_req:'请输入正确格式的电子邮箱(建议qq邮箱)',
    follow:'请遵守相关法律与法规，文明评论。O(∩_∩)O',
    list:'评论列表',
    reset:'重置',
    submit:'立即评论',
    toobig:'再大就受不了了!',
    toosmall:'再小就要用放大镜看了!',
    detail_ok:'评论成功',
    detail_fail:'评论失败',
    noempty:'请先填写！',
    recommend:'推荐文章',
    index:'首页',
    it:'技术文章',
    diary: '个人随笔',
    me:'关于我',
    about:'关于FZS',
    use:'FZS在用',
    contact:'联系FZS',
    home:'主页',
    mail:'邮箱',
    notsearch:'搜索次数过多，请稍后搜索！',
    nodata:'暂无数据！',
    common:{
        neterror:'网络异常',
        back:'返回',
        loading:'玩命加载中...',
        button:'我是有底线的',
        detail:'查看详情',
        home:'首页',
        current:'当前位置',
        more:'文章详情',
        zan:'谢谢您的赞！',
        zaned:'您已点过赞了！',
        submit:'发表评论',
        wechat:'微信'
    }
}


//////////////////
// WEBPACK FOOTER
// ./lang/zh.js
// module id = gdy5
// module chunks = 1